import { isSameDay, isToday } from './dateUtils';
import { lastDismissedStorage, hasUserExceededPageViewLimit } from './loginNudgeUtils';

const shouldShow = () => {
  const lastDismissDates = lastDismissedStorage.get();
  let firstDate;
  let secondDate;
  if (lastDismissDates.date) {
    // backwards compatibility with the old MpLoginDismissDate object (which is now an array)
    firstDate = new Date(lastDismissDates.date);
    lastDismissedStorage.set([lastDismissDates.date]);
  } else {
    firstDate = lastDismissDates[0] ? new Date(lastDismissDates[0]) : null;
    secondDate = lastDismissDates[1] ? new Date(lastDismissDates[1]) : null;
  }
  // If no dismissals then show
  if (!firstDate && !secondDate) {
    return true;
  }

  // If two dismissals
  if (firstDate && secondDate) {
    // If two dismissals, one is today, the other is a different day, then check if 5+ pageViews
    if (isToday(secondDate) && !isSameDay(firstDate, secondDate)) {
      return hasUserExceededPageViewLimit();
    }

    // If two dismissals, that are both today, then do not show
    if (isToday(firstDate) && isToday(secondDate)) {
      return false;
    }

    // If second dismissal is not today then show
    return !isToday(secondDate);
  }

  // If single dismissal, on same day then check if 5+ pageViews, if not then show
  if (firstDate && !secondDate && isToday(firstDate)) {
    return hasUserExceededPageViewLimit();
  }
  return true;
};

export default shouldShow;
